(() => {
  if (window.__mayeModelInfo) return;
  window.__mayeModelInfo = true;

  // Tap (or click) the Model info label to open it; tapping anywhere else closes it
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-model-info-toggle]');
    const box = toggle ? toggle.closest('[data-model-info]') : null;

    document.querySelectorAll('[data-model-info].is-open').forEach((open) => {
      if (open === box) return;
      open.classList.remove('is-open');
      open.querySelector('[data-model-info-toggle]')?.setAttribute('aria-expanded', 'false');
    });

    if (!box) return;
    event.preventDefault();
    const isOpen = box.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(isOpen));
  });
})();